module.exports = __webpack_public_path__ + "components/carousel-photo-gallery/static/generic-bg--9-965b324b160e803ceb2e7b7feb7644be.jpg";